import React from "react";

import { ReactComponent as Anemo } from './assets/Anemo.svg';
import { ReactComponent as Cryo } from './assets/Cryo.svg';
import { ReactComponent as Electro } from './assets/Electro.svg';
import { ReactComponent as Geo } from './assets/Geo.svg';
import { ReactComponent as Pyro } from './assets/Pyro.svg';

const tabs = [
  {
    title: "Anemo",
    id: "Anemo",
    icon: <Anemo />,
  },
  {
    title: "Electro",
    id: "Electro",
    icon: <Electro />,
  },
  {
    title: "Geo",
    id: "Geo",
    icon: <Geo />,
  },
  {
    title: "Cryo",
    id: "Cryo",
    icon: <Cryo />,
  },
  {
    title: "Pyro",
    id: "Pyro",
    icon: <Pyro />,
  }
];

export default tabs;
